// extracted by mini-css-extract-plugin
export default {"label":"b3CVjt","icon":"c3CVjt","left":"d3CVjt","right":"e3CVjt","noLabel":"f3CVjt","inputWithLeftIcon":"g3CVjt","input":"h3CVjt"};